import React, { type ReactNode } from 'react';
type PageHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  children?: ReactNode;
};
export function PageHero({
  eyebrow,
  title,
  description,
  image,
  children
}: PageHeroProps) {
  return <section className="relative flex min-h-[430px] items-end overflow-hidden bg-[#172a27] text-[#f7f4ec]" data-id="element-266" data-mp="3tbwpe5fjijgk">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-267" data-mp="25c0ar91plm6" />
      <div className="absolute inset-0 bg-[#0d1c19]/75" data-id="element-268" data-mp="urwtlx9307sd" />
      <div className="relative mx-auto w-full max-w-7xl px-5 pb-14 pt-36 sm:px-8 lg:px-10" data-id="element-269" data-mp="uremg5kvs95o">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#D9CAA0]" data-id="element-270" data-mp="g2qt85yicbiw">
          {eyebrow}
        </p>
        <h1 className="mt-4 max-w-3xl font-display text-5xl leading-[0.98] sm:text-6xl" data-id="element-271" data-mp="l0a734rammab">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-8 text-stone-200 sm:text-lg" data-id="element-272" data-mp="1dinyomm1dc0y">
          {description}
        </p>
        {children && <div className="mt-8" data-id="element-273" data-mp="32jdhskdrvhbr">{children}</div>}
      </div>
    </section>;
}